import Styled from 'styled-components'

export const SearchContainer = Styled.div`
  background: var(--background-app);
  border-bottom: 1px solid #C6C6C5;
  padding: 16px 32px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  box-shadow: 1px 1px 8px 0px rgba(0, 0, 0, 0.16);
  width: 100%;
`

export const SearchTitle = Styled.p`
  font-family: var(--font-family-base);
  font-weight: 600;
  font-size: 20px;
  color: var(--title-color);
  margin: 0;
  letter-spacing: -0.8px;
`

export const SearchContent = Styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

export const InputItem = Styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--text-color);
  width: 100%;

  .icon-container {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-color);

    svg {
        width: 100%;
        height: 100%;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    flex: 1;

    label {
      font-family: var(--font-family-base);
      font-weight: 400;
      font-size: 11px;
      color: var(--text-color);
      margin: 0;
      letter-spacing: -0.8px;
    }

    .value {
      font-family: var(--font-family-base);
      font-weight: 700;
      font-size: 15px;
      color: var(--text-color);
      letter-spacing: -0.8px;
    }
    
    input {
        border: none;
        outline: none;
        font-family: var(--font-family-base);
        font-weight: 700;
        font-size: 15px;
        color: var(--title-color);
        letter-spacing: -0.8px;
        padding: 0;
        width: 100%;
        background: transparent;

        &::placeholder {
            color: #BCBCBC;
        }
    }
  }
`

export const CheckboxRow = Styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    .label {
        font-family: var(--font-family-base);
        font-weight: 400;
        font-size: 12px;
        color: var(--text-color);
    }
`

export const GridInputs = Styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;

    @media (max-width: 576px) {
        grid-template-columns: 1fr;
    }
`

export const SearchButton = Styled.button`
  background: var(--button-primary-color);
  color: var(--button-primary-text);
  border: none;
  padding: 16px;
  width: 100%;
  font-family: var(--font-family-base);
  font-weight: 500;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: -0.8px;
  cursor: pointer;
  margin-top: 8px;

  &:hover {
    opacity: 0.9;
  }
`

export const SummaryContainer = Styled.div`
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
`

export const SummaryContent = Styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const SummaryTitle = Styled.p`
  font-family: var(--font-family-base);
  font-weight: 600;
  font-size: 14px;
  color: var(--title-color);
  margin: 0;
  line-height: normal;
`

export const SummaryDetails = Styled.p`
  font-family: var(--font-family-base);
  font-weight: 400;
  font-size: 14px;
  color: var(--text-color);
  margin: 0;
  line-height: normal;
`

export const EditButton = Styled.p`
  font-family: var(--font-family-base);
  font-weight: 600;
  font-size: 14px;
  color: var(--primary-color);
  margin: 0;
  text-decoration: underline;
  cursor: pointer;
`

export const FilterSortContainer = Styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: transparent;
  width: 100%;
`

export const FilterButton = Styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: var(--background-app);
  border: 1px solid #7D8E8F;
  border-radius: 0px;
  color: #7D8E8F;
  font-family: var(--font-family-base);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
    color: #4B5A5B;
  }
`

export const SortSelectWrapper = Styled.div`
  position: relative;
  width: 160px;
  font-family: var(--font-family-base);
  padding-top: 3px;

  button {
    width: 100%;
    height: 36px;
    background: transparent;
    border: none;
    border-bottom: 1px solid var(--text-color);
    font-size: 14px;
    font-weight: 600;
    color: var(--text-color);

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 10px 0 4px;
    gap: 6px;

    cursor: pointer;
  }

  .arrow-icon {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    font-size: 18px;
    color: var(--text-color);
    transition: transform 0.2s ease;
  }

  .arrow-icon.open {
    transform: translateY(-50%) rotate(180deg);
  }

  ul {
    position: absolute;
    top: 35px;
    left: 0;
    width: 100%;

    background: white;
    border: 1px solid #9DB7C3;
    border-radius: 4px;

    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
    padding: 6px 0;

    z-index: 10;

    animation: fadeIn 0.18s ease-out;
  }

  li {
    list-style: none;
    padding: 10px 14px;
    font-size: 15px;
    font-weight: 400;
    color: #000;

    cursor: pointer;
  }

  li:active {
    background: #f5f7f8;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
